export type PlotPortfolioProduct = {
  id: string;
  name: string;
  display_name: string;
  initial_setup_cost_credits: number;
  plot_creation_cost_credits: number;
  max_plots: number | null;
  max_hectares: number | null;
  created_at: string;
  modified_at: string;
};

/**
 * GET /api/v1/subscriptions/plot-portfolio-products/
 */
export const GET_PLOT_PORTFOLIO_PRODUCTS_PATH = 'subscriptions/plot-portfolio-products/';
export type GetPlotPortfolioProductsRequestQueryParams =
  | {
      limit?: number;
      offset?: number;
    }
  | undefined;
export type GetPlotPortfolioProductsSuccessDto = {
  count: number;
  next: string | null;
  previous: string | null;
  results: PlotPortfolioProduct[];
};
export type GetPlotPortfolioProductsErrorDto = Error;

/**
 * POST /api/v1/subscriptions/plot-portfolio-products/
 */
export const POST_PLOT_PORTFOLIO_PRODUCT_PATH = 'subscriptions/plot-portfolio-products/';
export type PostPlotPortfolioProductRequestBodyData = {
  name: string;
  display_name: string;
  initial_setup_cost_credits: number;
  plot_creation_cost_credits: number;
  max_plots?: number | null;
  max_hectares?: number | null;
};
export type PostPlotPortfolioProductErrorDto = Error;

/**
 * PATCH /api/v1/subscriptions/plot-portfolio-products/{id}/
 */
export const PATCH_PLOT_PORTFOLIO_PRODUCT_PATH = 'subscriptions/plot-portfolio-products/{id}/';
export type PatchPlotPortfolioProductRequestPathVariables = { id: string };
export type PatchPlotPortfolioProductRequestBodyData = Partial<PostPlotPortfolioProductRequestBodyData>;
export type PatchPlotPortfolioProductErrorDto = Error;

/**
 * DELETE /api/v1/subscriptions/plot-portfolio-products/{id}/
 */
export const DELETE_PLOT_PORTFOLIO_PRODUCT_PATH = 'subscriptions/plot-portfolio-products/{id}/';
export type DeletePlotPortfolioProductRequestPathVariables = { id: string };
export type DeletePlotPortfolioProductErrorDto = Error;
